import { Space } from '##/mixs/MixSpace';

import { ListPropSize } from '../types';

export const mapVerticalSpase: Record<ListPropSize, Space> = {
  xs: '2xs',
  s: '2xs',
  m: 'xs',
  l: 'xs',
};
